import { Spinner } from '@synapex/frontend-shared/ui/Loading';

import classes from './Loading.module.scss';

export type LoadingProps = {};
export const Loading = ({}: LoadingProps) => {
  return (
    <div className={classes.root}>
      <Spinner size={84} thickness={4} className={classes.spinner} />
    </div>
  );
};
